import React, { useState } from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./together.css";

function Contact() {
  const ref = useScrollReveal();
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("sending");

    const form = e.currentTarget;
    const data = {
      name: form.elements.namedItem("name").value,
      email: form.elements.namedItem("email").value,
      company: form.elements.namedItem("company").value,
      message: form.elements.namedItem("message").value,
    };

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error();
      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
    }
  }

  return (
    <section ref={ref} id="contact" className="contact reveal">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">06</span>
          <h2 className="section-title contact-title-large">Let's Work<br />Together</h2>
        </div>

        <div className="contact-body reveal-child" style={{ '--i': 1 }}>
          <p className="contact-text">
            I'm always interested in hearing about new projects and opportunities.
            Whether you're looking to build something or just want to connect, reach out.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name" className="form-label font-mono">Name</label>
              <input id="name" name="name" type="text" required placeholder="Your name" className="form-input" />
            </div>
            <div className="form-group">
              <label htmlFor="email" className="form-label font-mono">Email</label>
              <input id="email" name="email" type="email" required placeholder="you@example.com" className="form-input" />
            </div>
            <div className="form-group">
              <label htmlFor="company" className="form-label font-mono">Company</label>
              <input id="company" name="company" type="text" placeholder="Your company (optional)" className="form-input" />
            </div>
            <div className="form-group">
              <label htmlFor="message" className="form-label font-mono">Message</label>
              <textarea id="message" name="message" rows={4} required placeholder="What's on your mind?" className="form-input form-textarea" />
            </div>

            {status === "success" && <p className="form-status success font-mono">Message sent!</p>}
            {status === "error" && <p className="form-status error font-mono">Something went wrong. Try again.</p>}

            <button type="submit" disabled={status === "sending"} className="btn btn-primary form-submit">
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        <div className="contact-footer reveal-child" style={{ '--i': 2 }}>
          <span className="footer-text font-mono">© 2026 Beaux Dolf</span>
        </div>
      </div>
    </section>
  );
}

export default Contact;
